import pluralize from 'pluralize';

export default function numString(count: number, plural = 'items') {
  return `${count} ${count === 1 ? pluralize.singular(plural) : plural}`;
}
